<div class="flex flex-row gap-4 h-full min-h-[400px]">
  <!-- Linke Spalte: Aktive Regeln -->
  <div class="w-60 shrink-0 overflow-y-auto">
    <h6 class="text-sm font-semibold mb-2 text-base-content">Aktive Regeln</h6>
    <div class="space-y-1 text-xs">
      <div *ngFor="let project of projects">
        <ng-container *ngIf="project.hasPriorityWithRule()">
          <hawk-expand-bar-header
                  [description]="project.project_name"
                  [isExpanded]="expandProjects.includes(project)"
                  [leftAligned]="true"
                  [fontSize]="'.75rem'"
                  class="w-full"
                  (toggle)="$event ? addToExpandProjects(project) : removeFromExpandProjects(project)">
          </hawk-expand-bar-header>
          <div *ngIf="expandProjects.includes(project)" class="ml-2 space-y-0.5">
            <ng-container *ngFor="let priority of project.priorities">
              <div *ngIf="priorityHasRule(priority)"
                   (click)="selectProjectAndPriority(project, priority)"
                   class="flex items-center justify-between px-2 py-1.5 rounded cursor-pointer transition-colors"
                   [class.bg-primary]="priority == config?.project_priority?.priority"
                   [class.text-primary-content]="priority == config?.project_priority?.priority"
                   [class.hover:bg-base-200]="priority != config?.project_priority?.priority"
                   [class.bg-base-300]="priority != config?.project_priority?.priority">
                <span class="flex-1 truncate">{{priority.name}}</span>
                <span class="text-xs opacity-70">{{PASettingsControl.Instance.getAdditionalPriorityTimeRules(priority).length}}</span>
              </div>
            </ng-container>
          </div>
        </ng-container>
      </div>
    </div>
  </div>

  <!-- Rechte Spalte: Formular -->
  <div class="flex-1 bm-card bm-card-border border-base-300 bg-base-100 overflow-auto">
    <form [formGroup]="timePredictionRuleForm" (submit)="saveTimePredictionRule()" class="bm-card-body">

      <!-- Priorität auswählen -->
      <h6 class="text-sm font-semibold mb-2">Priorität auswählen</h6>
      <div class="flex flex-wrap gap-2 mb-4">
        <fieldset class="bm-fieldset w-64">
          <label class="bm-fieldset-label text-xs">Projekt</label>
          <select class="bm-select bm-select-sm w-full"
                  [ngModel]="config.project_priority.project"
                  [ngModelOptions]="{standalone: true}"
                  (ngModelChange)="selectProject($event)">
            <option [ngValue]="null">-- Projekt wählen --</option>
            <option *ngFor="let project of searchProjects || projects" [ngValue]="project">
              {{project.project_name}}
            </option>
          </select>
        </fieldset>

        <fieldset class="bm-fieldset w-64">
          <label class="bm-fieldset-label text-xs">Priorität</label>
          <select class="bm-select bm-select-sm w-full"
                  [disabled]="!config?.project_priority?.project"
                  [ngModel]="config.project_priority.priority"
                  [ngModelOptions]="{standalone: true}"
                  (ngModelChange)="selectPriority($event)">
            <option [ngValue]="null">-- Priorität wählen --</option>
            <option *ngFor="let priority of config?.project_priority?.project?.priorities || []" [ngValue]="priority">
              {{priority.name}}
            </option>
          </select>
        </fieldset>
      </div>

      <!-- Definierte Regeln -->
      <div *ngIf="shownPriorityRules.length" class="mb-4">
        <h6 class="text-sm font-semibold mb-2">Definierte Regeln</h6>
        <div class="space-y-1 max-h-28 overflow-auto">
          <div *ngFor="let rule of shownPriorityRules; let i = index"
               (click)="editRule(rule)"
               class="flex items-center gap-2 px-3 py-2 text-xs bg-base-200 rounded cursor-pointer hover:bg-base-300 transition-colors">
            <span class="font-mono text-base-content/60">#{{i + 1}}</span>
            <span class="px-2 py-0.5 bg-base-300 rounded">Auftrag {{rule.step_start}}-{{rule.step_end}}</span>
            <span class="flex-1 truncate">{{rule.technician == 'default' ? 'Alle Techniker' : rule.technician.getFullName(24)}}</span>
            <span class="px-2 py-0.5 bg-info/20 text-info rounded text-xs">
              {{rule.timePredictionFunctionWrapper.type == 'absolute' ? 'Absolut' : 'Linear'}}
            </span>
            <span class="font-semibold text-success">+{{rule.timePredictionFunctionWrapper.y_offset_value}}%</span>
            <button type="button" class="bm-btn bm-btn-ghost bm-btn-xs text-error" (click)="$event.stopPropagation(); deleteRule(rule)">
              <fa-icon [icon]="faTrash"></fa-icon>
            </button>
          </div>
        </div>
      </div>

      <!-- Neue Regel Button -->
      <div *ngIf="!editTimePredictionRule && config?.project_priority?.priority" class="mb-4">
        <button type="button" class="bm-btn bm-btn-primary bm-btn-sm" (click)="addTimePredictionRuleForPriority(config?.project_priority?.priority)">
          + Neue Rampup-Regel
        </button>
      </div>

      <!-- Regel bearbeiten -->
      <div *ngIf="editTimePredictionRule" class="mb-4 p-4 bg-base-200 rounded-lg">
        <h6 class="text-sm font-semibold mb-3">Regel bearbeiten</h6>

        <div class="flex flex-wrap gap-3 mb-4">
          <fieldset class="bm-fieldset">
            <label class="bm-fieldset-label text-xs">Ab Auftrag #</label>
            <input type="number" min="1"
                   formControlName="step_from"
                   class="bm-input bm-input-sm w-24"
                   [(ngModel)]="editTimePredictionRule.step_start"
                   (ngModelChange)="update(true)">
          </fieldset>

          <fieldset class="bm-fieldset">
            <label class="bm-fieldset-label text-xs">Bis Auftrag #</label>
            <input type="number" [min]="editTimePredictionRule.step_start + 1"
                   formControlName="step_until"
                   class="bm-input bm-input-sm w-24"
                   [(ngModel)]="editTimePredictionRule.step_end"
                   (ngModelChange)="update(true)">
          </fieldset>

          <fieldset class="bm-fieldset">
            <label class="bm-fieldset-label text-xs">Für Techniker</label>
            <select formControlName="technician"
                    class="bm-select bm-select-sm w-48"
                    [(ngModel)]="editTimePredictionRule.technician"
                    (ngModelChange)="update(true)">
              <option value="default">Alle Techniker</option>
              <option *ngFor="let technician of technicians" [ngValue]="technician">
                {{technician.getFullName(30)}}
              </option>
            </select>
          </fieldset>
        </div>

        <h6 class="text-sm font-semibold mb-3">Zusätzliche Zeit</h6>
        <div *ngIf="editTimePredictionRule?.timePredictionFunctionWrapper" class="flex flex-wrap gap-3">
          <fieldset class="bm-fieldset">
            <label class="bm-fieldset-label text-xs">Funktionstyp</label>
            <select formControlName="function_type"
                    class="bm-select bm-select-sm w-40"
                    [(ngModel)]="editTimePredictionRule.timePredictionFunctionWrapper.type"
                    (ngModelChange)="editTimePredictionRule.setTimePredictionFunctionWrapper($event); update(true)">
              <option value="absolute">Absoluter Wert</option>
              <option value="linear">Linear sinkend</option>
            </select>
          </fieldset>

          <fieldset class="bm-fieldset">
            <label class="bm-fieldset-label text-xs">Zusätzliche Zeit (%)</label>
            <input type="number" min="0"
                   formControlName="function_y_value"
                   class="bm-input bm-input-sm w-24"
                   [(ngModel)]="editTimePredictionRule.timePredictionFunctionWrapper.y_offset_value"
                   (ngModelChange)="update(true)">
          </fieldset>
        </div>
      </div>

      <!-- Chart -->
      <div class="py-4 border-t border-base-300" [class.hidden]="!editTimePredictionRule && !shownPriorityRules?.length">
        <div class="chart-container mx-auto">
          <canvas id="MyChart">{{chart}}</canvas>
        </div>
      </div>

      <!-- Buttons -->
      <div *ngIf="editTimePredictionRule && config?.project_priority?.priority" class="flex gap-2 pt-4 border-t border-base-300">
        <button type="submit" class="bm-btn bm-btn-primary bm-btn-sm">Regel speichern</button>
        <button type="button" class="bm-btn bm-btn-error bm-btn-sm" (click)="abortRuleChange()">Abbrechen</button>
      </div>
    </form>
  </div>
</div>
